export default __webpack_public_path__ + "static/media/audi1.cae8b9a1.jpeg";